import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
const BOOKING_URL = 'https://appointments.4patientcare.app/?CoverKey=5118&Source=website%20WebSchedV4&ReferredBy=Unknon&Gcount=0';
const DOCTOR_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/hEwASmNcZXFLV28cdyU94k/Dr_Nnabue__1_-removebg-preview.png';
export function BookingCTA() {
  return <section className="bg-brand-dark relative overflow-hidden pt-16 md:pt-24 pb-0" data-id="element-121">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 2px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-122"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-123">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 lg:gap-20" data-id="element-124">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-1/2 pb-16 md:pb-24 text-center md:text-left" data-id="element-125">
            <span className="inline-block text-brand-gold uppercase tracking-wider text-sm font-bold mb-3" data-id="element-126">
              Ready for Better Vision?
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-127">
              Book Your Appointment with Dr. Nnabue
            </h2>
            <p className="text-lg text-white/80 mb-8 max-w-xl mx-auto md:mx-0 leading-relaxed" data-id="element-128">
              Experience personalized eye care from a team that truly cares
              about your vision. With six convenient locations across Maryland,
              quality care is always close by.
            </p>

            <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 bg-brand-gold text-white px-8 py-4 rounded-button font-heading font-bold text-lg hover:bg-brand-gold-light hover:scale-105 transition-all duration-300 shadow-xl focus-ring group" data-id="element-129">
              <CalendarIcon className="w-5 h-5 group-hover:rotate-12 transition-transform" data-id="element-130" />
              Schedule Your Visit
            </a>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full md:w-1/2 flex justify-center md:justify-end items-end h-full self-end" data-id="element-131">
            <img src={DOCTOR_IMAGE_URL} alt="Dr. Nnabue smiling" className="w-full max-w-[600px] object-contain object-bottom drop-shadow-2xl" style={{
            maxHeight: '650px'
          }} loading="lazy" data-id="element-132" />
          </motion.div>
        </div>
      </div>
    </section>;
}